var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { observer } from 'mobx-react-lite';
import { useHistory, useLocation } from 'react-router-dom';
import * as React from 'react';
import { formatText } from 'bernie-l10n';
import { mergeQueryString, updateSearch } from 'bernie-core';
import { UitkTextInput } from 'uitk-react-input';
import { ActivityGroupViewType } from '../../common/__generated__/api';
import { useStores } from '../../utils/hooks';
import { getPageId } from '../../helpers/common-helper';
import { getUpdatedFilterQueryObject } from '../srp/sort-filter/filter-helper';
var NOT_FOUND_INDEX = -1;
var ENTER_CHAR_CODE = 13;
export var KeywordTextInput = observer(function (_a) {
  var isCarousel = _a.isCarousel,
    inDialog = _a.inDialog;
  var _b = useStores(),
    analytics = _b.analytics,
    activitySearchStore = _b.activitySearchStore;
  var history = useHistory();
  var location = useLocation();
  var tileIndex = activitySearchStore.activityGroups.findIndex(function (activityGroup) {
    return activityGroup.viewType === ActivityGroupViewType.KEYWORD_SEARCH;
  });
  var keywordData = {
    analytics: {
      linkName: 'keyword-search-done',
      referrerId: "".concat(getPageId(activitySearchStore), ".filterSort.SearchActivity")
    },
    placeholder: activitySearchStore.sortAndFilterObject.keywordPlaceholder,
    keyword: activitySearchStore.sortAndFilterObject.keywordValue
  };
  var keywordClearData = {
    linkName: 'keyword-search-cleared',
    referrerId: "LX.".concat(getPageId(activitySearchStore), ".filterSort.SearchActivity.Clear")
  };
  if (isCarousel && tileIndex > NOT_FOUND_INDEX) {
    keywordData = {
      analytics: activitySearchStore.activityGroups[tileIndex].activityTiles[0].analytics,
      placeholder: activitySearchStore.activityGroups[tileIndex].activityTiles[0].placeholder || '',
      keyword: activitySearchStore.activityGroups[tileIndex].activityTiles[0].searchTerm || ''
    };
    keywordClearData = activitySearchStore.activityGroups[tileIndex].activityTiles[0].clearAnalytics;
  }
  var handleClear = function () {
    analytics.trackEvent(keywordClearData.referrerId, keywordClearData.linkName, null, true);
    if (isCarousel || !inDialog) {
      var newQueryString = mergeQueryString(location.search, __assign(__assign({}, getUpdatedFilterQueryObject(activitySearchStore)), {
        sort: activitySearchStore.sortAndFilterObject.initialSelectedSort,
        slimSearchKeyword: '',
        seeAll: activitySearchStore.sortAndFilterObject.initialSeeAllOption,
        pwaDialog: ''
      }));
      updateSearch({
        history: history,
        location: location,
        newParams: newQueryString,
        newState: {},
        replace: true
      });
    } else {
      activitySearchStore.sortAndFilterObject.keywordValue = '';
    }
  };
  var updateKeyword = function (event) {
    if (isCarousel) {
      activitySearchStore.activityGroups[tileIndex].activityTiles[0].searchTerm = event.target.value;
    } else {
      activitySearchStore.sortAndFilterObject.keywordValue = event.target.value;
    }
  };
  var handleKeywordSubmit = function (event) {
    var _a;
    if (event.charCode === ENTER_CHAR_CODE || event.which === ENTER_CHAR_CODE) {
      var newQueryString = mergeQueryString(location.search, __assign(__assign({}, getUpdatedFilterQueryObject(activitySearchStore)), {
        sort: activitySearchStore.sortAndFilterObject.initialSelectedSort,
        slimSearchKeyword: isCarousel ? activitySearchStore.activityGroups[tileIndex].activityTiles[0].searchTerm : activitySearchStore.sortAndFilterObject.keywordValue,
        seeAll: activitySearchStore.sortAndFilterObject.initialSeeAllOption,
        pwaDialog: ''
      }));
      var keywordEnteredInPageInputField = isCarousel && ((_a = activitySearchStore.activityGroups[tileIndex].activityTiles[0].searchTerm) === null || _a === void 0 ? void 0 : _a.length) > 0;
      if (activitySearchStore.sortAndFilterObject.keywordValue.length > 0 || keywordEnteredInPageInputField) {
        analytics.trackEvent(keywordData.analytics && keywordData.analytics.referrerId, keywordData.analytics && keywordData.analytics.linkName, analytics.omnitureData, null, true);
      }
      updateSearch({
        history: history,
        location: location,
        newParams: newQueryString,
        newState: {},
        replace: true
      });
    }
  };
  return React.createElement(UitkTextInput, {
    "data-testid": "keyword-text-input--input",
    icon: "search",
    label: formatText('lx.search.freetext.label'),
    name: "searchKeyword",
    id: "searchKeyword",
    placeholder: keywordData.placeholder || formatText('lx.search.freetext.placeholder'),
    hasVisibleLabel: false,
    onChange: updateKeyword,
    onKeyPress: handleKeywordSubmit,
    value: keywordData.keyword,
    hasClearButton: true,
    handleClear: handleClear
  });
});